interface iSimpleGuard {
  canAccess: boolean;
  children?: React.ReactNode;
}

export function SimpleGuard({ canAccess, children }: iSimpleGuard) {
  if (canAccess) {
    return <>{children}</>;
  }

  return <></>;
}
